import { subscribe, unsubscribe } from "../actions/socket";
import { isToday } from '../helpers/common';
import {
    SUBSCRIBE_MAP_EG_KPI, UNSUBSCRIBE_MAP_EG_KPI, LIVE_MESSAGE
} from '../constants/action-types';
import {
    TOPIC_SENSOR, TOPIC_KPI_EG, TOPIC_LATEST_KPI_EG, TOPIC_LOAD_EG, GROUP_MAP_KPI
} from '../constants';

const subscribeMapKPI = (store, action) => {
    const range = store.getState().analyze.searchParams.range;
    const { deviceId, crewId, egId, isTruck } = action.params;

    if (isToday(range)) {
        const notifications = [
            // { deviceId, action: TOPIC_LATEST_EG_SENSOR, parameters: { sensor: "gps", equipment_group_uuid: egId } },
            // { deviceId: deviceId, name: TOPIC_SENSOR, parameters: { sensor_type: "gps" } },
            // { deviceId, action: TOPIC_LATEST_EG_SENSOR, parameters: { sensor: "battery_level,pto,fuel_level,grain_yield,grain_moisture", equipment_group_uuid: egId } },
            { deviceId: deviceId, name: TOPIC_SENSOR, parameters: { sensor_type: "battery_level,pto,fuel_level,grain_yield,grain_moisture" } }
        ];

        if (isTruck && crewId) {
            notifications.push({ deviceId: crewId, name: TOPIC_LOAD_EG });
        } else if (!isTruck) {
            notifications.push({ deviceId: egId, action: TOPIC_LATEST_KPI_EG, parameters: { include_work: true } });
            notifications.push({ deviceId: egId, name: TOPIC_KPI_EG });
        }

        store.dispatch(subscribe(notifications, `${GROUP_MAP_KPI}${egId}`));
    }
    else store.dispatch(unsubscribe(`${GROUP_MAP_KPI}${egId}`));
    return;
}

const unsubscribeMapKPI = (store, action) => {
    store.dispatch(unsubscribe(`${GROUP_MAP_KPI}${action.egId}`));
    return;
}

const mapMiddleware = store => {
    return next => action => {
        switch (action.type) {
            case SUBSCRIBE_MAP_EG_KPI:
                subscribeMapKPI(store, action);
                break;
            case UNSUBSCRIBE_MAP_EG_KPI:
                unsubscribeMapKPI(store, action);
                break;
            case LIVE_MESSAGE:
                action = { ...action, range: store.getState().analyze.searchParams.range };
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default mapMiddleware;